export const swarm_yellow = '#E3C63F';

export const colegioColor = [
	{ id: 'Isabel Le Brun', color: '#9932CC' },
	{ id: 'Montserrat Robert de García', color: '#FFA500' },
	{ id: 'Thomas Alva Edison', color: '#D2691E' },
	{ id: 'Alberto Blest Gana', color: '#FF00FF' },
	{ id: 'Santa Juana de Lestonnac', color: '#FAFAD2' },
	{ id: 'Domingo Santa María', color: '#87CEEB' },
	{ id: 'Rebeca Matte Bello', color: '#C0C0C0' },
	{ id: 'Juana Atala de Hirmas', color: '#556B2F' },
	{ id: 'Reverendo Padre Gustavo Le Paige', color: '#7CFC00' },
	{ id: 'Cumbre de Cóndores Oriente', color: '#FFA07A' },
	{ id: 'Capitán José Luis Araneda', color: '#708090' },
	{ id: 'Lo Velásquez', color: '#800000' },
	{ id: 'Cumbre de Cóndores Poniente', color: '#B0E0E6' },
	{ id: 'Alejandro Gorostiaga Orrego', color: '#A52A2A' },
	{ id: 'Manuel Bulnes Prieto', color: '#DC143C' }
];
